<template>
  <div class="geodesist-calls-block">
    <CustomTable
      title="Вызовы геодезиста"
      :rowsData="rowsData"
      :columns="columns"
      :loading="isFetching"
      :custom-body="true"
      :show-search="true"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            {{ formatDate(props.row.call_date) }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.resident_name || '-' }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.block_name || '-' }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.level_num || '-' }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <div style="display: flex; gap: 10px; justify-content: center; align-items: center; flex-wrap: wrap;">
              <div v-if="props.row.is_signed" style="display: flex; align-items: center; gap: 8px;">
                <q-icon name="verified" color="green" size="20px" />
                <span style="color: green; font-size: 13px; font-weight: 500;">Подписано</span>
                <q-btn
                  v-if="props.row.doc_url"
                  size="sm"
                  color="primary"
                  icon="download"
                  @click="downloadDoc(props.row.doc_url)"
                >
                  <q-tooltip>Скачать документ</q-tooltip>
                </q-btn>
              </div>
              <div v-else-if="props.row.doc_url" style="display: flex; align-items: center; gap: 8px;">
                <q-icon name="check_circle" color="green" size="20px" />
                <span style="color: green; font-size: 13px;">Документ загружен</span>
                <q-btn
                  size="sm"
                  color="primary"
                  icon="download"
                  @click="downloadDoc(props.row.doc_url)"
                >
                  <q-tooltip>Скачать документ</q-tooltip>
                </q-btn>
              </div>
              <q-btn
                v-if="!props.row.is_signed"
                size="sm"
                :color="props.row.doc_url ? 'orange' : 'green'"
                icon="upload"
                :loading="uploading[props.row.help_call_id]"
                @click="openFileDialog(props.row.help_call_id)"
              >
                <q-tooltip>{{ props.row.doc_url ? 'Заменить документ' : 'Добавить документ' }}</q-tooltip>
              </q-btn>
              <q-btn
                v-if="!props.row.is_signed && props.row.doc_url && props.row.resident_id && props.row.project_type_id && props.row.project_entrance_id"
                size="sm"
                color="primary"
                icon="description"
                @click="goToSigning(props.row)"
              >
                Перейти к подписанию
                <q-tooltip>Открыть вкладку подписания документов</q-tooltip>
              </q-btn>
            </div>
            <input
              :ref="el => setFileInputRef(el, props.row.help_call_id)"
              type="file"
              :id="`fileInput_${props.row.help_call_id}`"
              style="display: none"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              @change="(e) => handleFileSelect(e, props.row.help_call_id)"
            />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { getGeodesistCalls, addGeodesistDoc } from "@/views/GeodesistCalls/services";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

export default {
  name: "GeodesistCallsBlock",
  components: { CustomTable, CustomTableCell },
  props: {
    data: { type: Object, default: null },
    params: { type: Object, default: () => ({}) },
    onGoToDocumentTab: { type: Function, default: null },
  },
  data() {
    return {
      isFetching: false,
      rowsData: [],
      uploading: {},
      fileInputRefs: {},
      columns: [
        {
          name: "call_date",
          label: "Дата вызова",
          field: "call_date",
          align: "center",
          sortable: true,
        },
        {
          name: "resident_name",
          label: "ЖК",
          field: "resident_name",
          align: "left",
          sortable: true,
        },
        {
          name: "block_name",
          label: "Блок",
          field: "block_name",
          align: "left",
          sortable: true,
        },
        {
          name: "level_num",
          label: "Этаж",
          field: "level_num",
          align: "center",
          sortable: true,
        },
        {
          name: "doc_url",
          label: "Документ",
          align: "center",
        },
      ],
    };
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? dateStr : date.toLocaleDateString("ru-RU");
    },
    async getData() {
      this.isFetching = true;
      const params = {};
      if (this.params?.project_id != null) params.project_id = this.params.project_id;
      const res = await getGeodesistCalls(params);
      this.rowsData = res || [];
      this.isFetching = false;
    },
    setFileInputRef(el, help_call_id) {
      if (el) this.fileInputRefs[help_call_id] = el;
    },
    openFileDialog(help_call_id) {
      const input = this.fileInputRefs[help_call_id] || document.getElementById(`fileInput_${help_call_id}`);
      if (input) input.click();
    },
    async handleFileSelect(event, help_call_id) {
      const file = event.target.files[0];
      if (!file) return;
      this.uploading[help_call_id] = true;
      const res = await addGeodesistDoc(file, help_call_id).catch(() => null);
      if (!res) {
        this.showErrorSnackbar("Ошибка при загрузке документа");
        this.uploading[help_call_id] = false;
        event.target.value = "";
        return;
      }
      this.showSucceedSnackbar("Документ успешно загружен");
      await this.getData();
      this.uploading[help_call_id] = false;
      event.target.value = "";
    },
    downloadDoc(doc_url) {
      if (!doc_url) return;
      // URL для скачивания документов (можно задать отдельно от API при локальной разработке)
      const docBaseUrl = (process.env.VUE_APP_DOCUMENT_BASE_URL || process.env.VUE_APP_API_URL || "http://localhost:8000").replace(/\/$/, "");
      const href = doc_url.startsWith("http") ? doc_url : `${docBaseUrl}${doc_url.startsWith("/") ? doc_url : "/" + doc_url}`;
      const link = document.createElement("a");
      link.href = href;
      link.target = "_blank";
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    goToSigning(row) {
      if (!row.resident_id || !row.project_type_id || !row.project_entrance_id) {
        this.showErrorSnackbar("Недостаточно данных для перехода к подписанию");
        return;
      }
      if (this.onGoToDocumentTab) {
        this.onGoToDocumentTab(row);
      }
    },
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar };
  },
};
</script>

<style scoped lang="scss">
.geodesist-calls-block {
  padding: 0;
}
</style>
